module.exports = {"450804001":"覃塘街道","450804101":"东龙镇","450804102":"三里镇","450804103":"黄练镇","450804104":"石卡镇","450804105":"五里镇","450804106":"樟木镇","450804107":"蒙公镇","450804200":"山北乡","450804204":"大岭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450804.json
// module id = 2131
// module chunks = 0